import { LandingHero } from "@/components/landing/LandingHero";
import { LandingValueProps } from "@/components/landing/LandingValueProps";
import { LandingAccounts } from "@/components/landing/LandingAccounts";
import { LandingDemo } from "@/components/landing/LandingDemo";
import { LandingCta } from "@/components/landing/LandingCta";
import { LandingFooter } from "@/components/landing/LandingFooter";

/**
 * Landing page publique SunMatch — route `/` (S7-5, GAP-3 ; copy V1 S16-3).
 *
 * Cadrage S7-1 § 1.1-1.4 :
 * - Rendu sous `<LandingLayout />` (option 2) → **pas** de `ConsentModal`.
 * - Sections dans l'ordre canonique : Hero (h1 unique) → Valeur → Comptes
 *   (avec/sans compte + teaser Enedis roadmap) → Démo → CTA secondaire →
 *   Footer.
 * - Responsive Tailwind par défaut (mobile / tablette / desktop).
 * - A11y WCAG AA cible projet (cf. `Landing.a11y.test.tsx`).
 *
 * Le wizard et le dashboard restent inchangés (cf. `router.tsx`).
 */
export function Landing(): JSX.Element {
  return (
    <>
      <main id="main-content">
        <LandingHero />
        <LandingValueProps />
        <LandingAccounts />
        <LandingDemo />
        <LandingCta />
      </main>
      <LandingFooter />
    </>
  );
}
